<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/* @import url("//unpkg.com/element-ui@2.15.6/lib/theme-chalk/index.css"); */
</style>



// WEBPACK FOOTER //
// src/App.vue